import React, { Fragment } from "react";
import { CardHeader } from "reactstrap";
import { H3, P } from "../../../../AbstractElements";
import { CommonCreativeCardHeaderProp } from "../../../../Type/CommonComponant";

const CommonCreativeCardHeader = ({ headerClass, titleClass, title, span }: CommonCreativeCardHeaderProp) => {
  return (
    <CardHeader className={headerClass}>
      <H3 className={titleClass}>{title}</H3>
      {span && (
        <P className="mt-1 f-m-light">
          {span.map((data, index) => (
            <Fragment key={index}>
              {data?.text} {data.code && <code>{data.code}</code>}
            </Fragment>
          ))}
        </P>
      )}
    </CardHeader>
  );
};

export default CommonCreativeCardHeader;
